import Skeleton from "react-loading-skeleton";

import { FieldControlContainer, FieldControlSkeleton } from "./styles";
import { CONTROLS } from "./constants";

const FieldControl = (props) => {
  const {
    id,
    type,
    variant,
    placeholder,
    isReadOnly,
    isDisabled,
    isRequired,
    showSkeleton,
    value,
    error,
    onChange,
    validateBeforeChange,
    setIsFormDisabled,
    size,
    ...rest
  } = props;

  const Control = CONTROLS[type] || CONTROLS.text;

  const setValue = (newValue) => {
    if (typeof newValue === "function") {
      onChange(newValue(value));
    } else {
      onChange(newValue);
    }
  };

  return (
    <FieldControlContainer>
      {showSkeleton ? (
        <FieldControlSkeleton type={type} size={size}>
          <Skeleton />
        </FieldControlSkeleton>
      ) : (
        <Control
          id={id}
          name={id}
          type={type}
          size={size}
          variant={variant}
          placeholder={placeholder}
          isReadOnly={isReadOnly}
          isDisabled={isDisabled}
          isRequired={isRequired}
          showSkeleton={showSkeleton}
          value={value}
          error={error}
          onChange={onChange}
          validateBeforeChange={validateBeforeChange}
          setIsFormDisabled={setIsFormDisabled}
          setValue={setValue}
          {...rest}
        />
      )}
    </FieldControlContainer>
  );
};

export default FieldControl;
